import React, { Component } from 'react';
//import logo from './logo.svg';
import { REACT_APP_URL } from '../services/api-config';
import '../css/main.css'
import './App.css';
import { BrowserRouter, Route } from 'react-router-dom'
import ItemView from './itemscreens/ItemView.js'
import WordSearchForm from './wordsearchscreens/WordSearchForm'
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import Menu from './Menu';
import {populateMessages, getLegends} from '../actions/index.js';
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
//import { BrowserRouter as Router, Route } from 'react-router-dom'


ReactGA.initialize("G-X7H7QEZXMH");
//ReactGA.pageview(window.location.pathname);


export  class App extends Component{


  componentDidMount() {
    //console.log(da)



    const {
      populateMessages,
      getLegends
    } = this.props;

   populateMessages();
   getLegends();


    //  setInterval( this.refreshMessages , 3000);
  //this._setInterval(this.refreshMessages, 1000);
  }


  render() {

    const {
      messages,
      loading
    } = this.props;

    return (

        <BrowserRouter>
      <div className="container-fluid">
        {/* location={this.props.location} match={this.props.match} */}

        <Route exact path={REACT_APP_URL+`:number?`} render={(props) => (


              <Menu {...props} data={messages} loading={loading}/>


        )}/>

        <Route exact path={REACT_APP_URL+`just/:number`}  render={(props) => (

            <ItemView {...props} newwindow={true}/>
        )}/>

          <Route exact path={REACT_APP_URL+`wordsearch/only`} render={(props) => (
            <WordSearchForm {...props} />
          )}/>



      </div>
</BrowserRouter>

    )

}
};

function mapStateToProps(state) {
  return {
    messages: state.messages,
    loading: state.loading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    populateMessages,
    getLegends
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js